const state = {
  userData: {
      Id: null,
      Nome: '',
      Email: '',
      PhoneNumber: '',
      UserName: '',
      grupo_economico: null,
      IsActive: false,
      Prestadores: [],
      permissao: {},
      PermissaoAcoes:{},
      UsuarioTradimus: false
  },
  grupo_economico: null,
  permissao: {},
  prestadores: [],
  accountUrl: '',
}

const mutations = {
  updateUserData: (state, obj) => {
    delete obj.sucesso
    delete obj.erros
    delete obj.mensagem
    state.userData = obj
    state.permissao = obj.Permissao? obj.Permissao : []
    state.prestadores = obj.Prestadores? obj.Prestadores : []
  },
}

const getters = {
  getUserData: state => () =>{
    return state.userData
  }
}

function keepSessionGrupoEconomico(userInfoResponse)
{
  let grupoEconomicoSession = sessionStorage.getItem('grupoEconomico')

  if(!grupoEconomicoSession)
  {
    return;
  }

    userInfoResponse.grupo_economico = grupoEconomicoSession;
}

function processUrlParams(userInfoResponse) {
  const grupoEconomico = sessionStorage.getItem('pending_grupoEconomico');
  if (grupoEconomico && userInfoResponse.UsuarioTradimus) {
    const grupoEconomicoId = parseInt(grupoEconomico);
    if (!isNaN(grupoEconomicoId)) {
      const originalGrupoEconomico = userInfoResponse.grupo_economico;
      userInfoResponse.grupo_economico = grupoEconomicoId;
      
      userInfoResponse.validate_grupo_economico_access = true;
      userInfoResponse.original_grupo_economico = originalGrupoEconomico;
      
      sessionStorage.removeItem('pending_grupoEconomico');
      console.log('Grupo econômico da URL aplicado temporariamente para validação:', grupoEconomicoId);
      
      const url = new URL(window.location.href);
      if (url.searchParams.has('grupoEconomico')) {
        url.searchParams.delete('grupoEconomico');
        window.history.replaceState({}, '', url.toString());
      }
    }
  }
}

const actions = {
  getUserData({commit}, data) {
    let { userData, tokenInfo } = data

    let obj = {
        query: [{ 
          Modulo: "portal",
          Acao: "getselfuser",
          Payload: {
            grupo_economico: Number(userData.grupo_economico)
          }
        }],
        token: tokenInfo.access_token
    }

    return this.dispatch("request/doRequest", obj)
      .then(response => {
        
        if(!response || response.isAxiosError || !response.IsActive) {
          this.requestAnswer = response && !response.IsActive? "Usuário ou senha inválidos!" : "";
          this.commit("hideLoader")
          return
        }        response = {
          ...userData,
          ...response
        };
        keepSessionGrupoEconomico(response)
        
        processUrlParams(response);
        commit("updateUserData", {...userData, ...response} )
        commit("permissions/updateGrupoEconomico", Number(response.grupo_economico), {root: true})

        return this.dispatch("request/saveTokenInfo", { token: tokenInfo, userData: response } , {root: true})
          .then(() => {
            return this.dispatch("permissions/getModulos", {grupoEconomico:response.grupo_economico}, {root: true});
          })
          .then(() => {
            if(response.UsuarioTradimus) {
              return this.dispatch("permissions/getGrupoEconomicoList", response.grupo_economico, {root: true})
            }

            return this.dispatch("permissions/getGrupoEconomicoById", response.grupo_economico, {root: true})
          })
          .then(() => {
            if (response.validate_grupo_economico_access && response.UsuarioTradimus) {
              const grupoEconomicoList = this.state.permissions.grupoEconomicoList;
              const grupoEconomicoId = Number(response.grupo_economico);
              
              if (!grupoEconomicoList || !grupoEconomicoList.some(geco => geco.grupo_id === grupoEconomicoId)) {
                console.warn('Acesso negado: Usuário não tem permissão para acessar o grupo econômico', grupoEconomicoId);
                console.log('Revertendo para grupo econômico original:', response.original_grupo_economico);
                
                const originalGrupoEconomico = Number(response.original_grupo_economico);
                commit("permissions/updateGrupoEconomico", originalGrupoEconomico, {root: true});
                
                return this.dispatch("permissions/getModulos", {grupoEconomico: originalGrupoEconomico}, {root: true});
              } else {
                console.log('Acesso validado com sucesso ao grupo econômico:', grupoEconomicoId);
              }
            }
            
            this.commit("hideLoader")
          });
      });
  }
}
export default {
  namespaced: true,
  root: true,
  state,
  actions,
  mutations,
  getters
}
